import React from "react";

export default function About() {
  return (
    <section id="about">
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            Hi, I'm Firas.
            <br className="hidden lg:inline-block" />I love to build amazing
            website .
          </h1>
          <p className="mb-8 leading-relaxed">
          I am a student in a master's degree in computer science, I have a fundamental degree in computer science in 2020.
          I am a web developer & programmer living in tunisia i make web applications .
          </p>
          <div className="flex justify-center">
            <a
              href="#contact"
              className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">
              Work With Me
            </a>
            <a
              href="https://github.com/Firashs01"
              className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
              My github 
            </a>
            <a
              href="https://www.linkedin.com/in/firas-hosni-4450a01b4/"
              className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
               LinkedIn
            </a>
          </div>
        </div>
        
      </div>
    </section>
  );
}